import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { CONSENT_EVENT, getConsent, initAnalytics, setConsent } from "@/lib/analytics";
import { useLanguage } from "@/i18n/LanguageContext";

export const CookieBanner = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const sync = () => {
      const c = getConsent();
      if (c === "accepted") initAnalytics();
      setVisible(c === null);
    };
    sync();
    window.addEventListener(CONSENT_EVENT, sync);
    return () => window.removeEventListener(CONSENT_EVENT, sync);
  }, []);

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t.cookies.title}
      data-testid="gdpr-cookie-consent-banner"
      className="fixed inset-x-4 bottom-4 z-[70] md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md text-left"
    >
      <div className="bg-white border border-neutral-200 rounded-lg p-5 md:p-6 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.35)]">
        <div className="flex items-start gap-4">
          <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-[#2E4FE6] text-white">
            <Cookie className="w-4 h-4" />
          </span>
          <div>
            <div className="font-archivo font-extrabold text-[#111]">{t.cookies.title}</div>
            <p className="mt-1.5 text-[13px] leading-relaxed text-neutral-600">
              {t.cookies.text}{" "}
              <Link to="/privacidade" data-testid="cookie-privacy-link" className="text-[#2E4FE6] font-semibold hover:underline">
                {t.cookies.more}
              </Link>
              .
            </p>
          </div>
        </div>
        <div className="mt-5 flex flex-col-reverse sm:flex-row gap-2.5 sm:justify-end">
          <button
            data-testid="cookie-reject-optional-button"
            onClick={() => setConsent("rejected")}
            className="rounded-md border border-neutral-200 px-5 py-2.5 text-sm font-semibold text-neutral-700 hover:text-[#111] hover:border-neutral-400 transition-colors"
          >
            {t.cookies.reject}
          </button>
          <button
            data-testid="cookie-accept-all-button"
            onClick={() => setConsent("accepted")}
            className="rounded-md bg-[#F2641E] hover:bg-[#dd560f] px-5 py-2.5 text-sm font-bold uppercase tracking-wide text-white transition-colors"
          >
            {t.cookies.accept}
          </button>
        </div>
      </div>
    </div>
  );
};
